import { makeAutoObservable } from 'mobx';
import { apiRequest } from '../helpers/request';
import { REQUEST_TYPE } from '../constants/base';
class AdminStore {
  loading: boolean = false;
  isProcessing: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading(value: boolean) {
    this.loading = value;
  }

  setProcessing(value: boolean) {
    this.isProcessing = value;
  }

  async getUsersWithCredits() {
    try {
      const res = await apiRequest('/admin/list/user', REQUEST_TYPE.GET);

      return res.response ?? [];
    } catch (e) {}
  }

  async changeCustomerCredit(
    customer: string,
    credits: number,
    action: 'grant' | 'deduct',
    type: 'company' | 'user' = 'company'
  ) {
    if (this.isProcessing) return;
    this.setProcessing(true);
    try {
      const res = await apiRequest('/admin/balance', REQUEST_TYPE.PUT, {
        customer: customer,
        credits,
        action,
        type,
      });
      this.setProcessing(false);

      return res;
    } catch (e) {
      this.setProcessing(false);
    }
  }
}

const adminStore = new AdminStore();
export default adminStore;
